package system.single

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.soywiz.korim.color.*
import component.*

class TrapAnimationSystem : IteratingSystem(family{ all(TrapComponent)}) {

    private val ANIMATION_TIME = PlayerTrapSystem.TRAP_TIME

    override fun onTickEntity(entity: Entity) {
        val trapComp = entity[TrapComponent]

        if (trapComp.userData.wasTouched) {
            if (trapComp.timeAccumulator >= ANIMATION_TIME) {
                trapComp.userData.setTouched(false)
                trapComp.timeAccumulator = 0f
//                trapComp.view.color = Colors.GREEN
                return
            }

            trapComp.timeAccumulator += deltaTime
//            trapComp.view.color = Colors.RED
        }
    }
}
